// Generated from doskai-contracts/contracts/config/country-launch-packages.v1.json. Do not edit.
export const COUNTRY_LAUNCH_PACKAGES = [
  {
    countryCode: 'IN',
    status: 'active',
    currencyCode: 'INR',
    legalEntity: 'DOSKAI_INDIA',
    payoutMinimumMinor: 500000,
    instantPayoutSupported: false,
    requiredCapabilities: [
      'legalEntity',
      'currency',
      'stripe',
      'tax',
      'webSubscriptions',
      'nativeSubscriptions',
      'nativeAds',
      'promos',
      'payouts',
      'kyc',
      'addresses',
      'checkout',
      'qa',
    ],
  },
  {
    countryCode: 'US',
    status: 'active',
    currencyCode: 'USD',
    legalEntity: 'DOSKAI_US_LLC',
    payoutMinimumMinor: 5000,
    instantPayoutSupported: true,
    requiredCapabilities: [
      'legalEntity',
      'currency',
      'stripe',
      'tax',
      'webSubscriptions',
      'nativeSubscriptions',
      'nativeAds',
      'promos',
      'payouts',
      'kyc',
      'addresses',
      'checkout',
      'qa',
    ],
  },
] as const;

export type ApprovedCountryCode = (typeof COUNTRY_LAUNCH_PACKAGES)[number]['countryCode'];
